<!-- 预警信息查看 -->
<template>
  <div class='warnInformationView'>
    <div class="sms_top">
        <div class="select">
          <span class="desc">起止时间:</span>
          <div class="block" style="display: inline-block;">
            <el-date-picker
              v-model="warnTMMin"
              value-format="yyyy-MM-dd HH:mm"
              format="yyyy-MM-dd HH:mm"
              type="datetime"
              placeholder="选择开始日期时间"
              :picker-options="Global.pickerOptionsStart(warnTMMax)"
              default-time="08:00:00"
              @change="Global.emptyQuery(warnTMMin,getTableData)">
            </el-date-picker>
            <span style="margin:0 5px;">至</span>
            <el-date-picker
              v-model="warnTMMax"
              value-format="yyyy-MM-dd HH:mm"
              format="yyyy-MM-dd HH:mm"
              type="datetime"
              placeholder="选择结束日期时间"
              :picker-options="Global.pickerOptionsEnd(warnTMMin)"
              default-time="08:00:00"
              @change="Global.emptyQuery(warnTMMax,getTableData)">
            </el-date-picker>
          </div>
        </div>
        <div class="sentType">
            <span class="fsfs">预警名称:</span>
            <div class="selectContent">
                <el-input @change="Global.emptyQuery(warnNM,getTableData)" clearable v-model="warnNM" placeholder="请输入预警名称"></el-input>
            </div>
        </div>
        <el-button id="search" @click="getTableData" type="primary" size="small" title="查询">查询</el-button>
        <span id="export" @click="exportdata"><span class="export-icon"></span>导出</span>
    </div>
    <div class="sms_bottom" ref="sms_bottom">
      <el-table
        v-loading="loading"
        :data="tableData"
        :height="height"
        border
        stripe
        @selection-change="handleCurrentChange"
      >
        <el-table-column type="index" align="center" header-align="center" label="序号" width="50" :index='(index)=>{return (index+1) + (pageIndex-1)*pageSize }'>
        </el-table-column>
        <el-table-column align="left" header-align="left" prop="adnm" label="重要村落" width="120">
        </el-table-column>
        <el-table-column align="left" header-align="left" prop="warnNM" label="预警名称" width="180">
        </el-table-column>
        <el-table-column align="left" header-align="left" prop="warnTypeNM" label="预警类型" width="80">
        </el-table-column>
        <el-table-column align="left" header-align="left" prop="warnStatusNM"  label="预警状态" width="110">
        </el-table-column>
        <el-table-column align="left" header-align="left" prop="warnGradeNM"  label="预警等级" width="100">
        </el-table-column>
        <el-table-column align="left" header-align="center" prop="warnDesc"  label="预警描述" :show-overflow-tooltip="true" min-width="250">
        </el-table-column>
        <el-table-column align="center" header-align="center" prop="warnSTM"  label="开始时间" width="160">
        </el-table-column>
        <el-table-column align="center" header-align="center" prop="warnETM"  label="结束时间" width="160">
        </el-table-column>
        <!-- <el-table-column align="left" header-align="left" prop="remark"  label="是否上报" width="80">
          <template slot-scope="scope">{{scope.row.isSb?"已上报":"未上报"}}</template>
        </el-table-column> -->
      </el-table>
      <!-- 添加分页 -->
      <el-pagination
        @size-change="handleSizeChangeDialog"
        @current-change="handleCurrentChangeDialog"
        :current-page="pageIndex"
        :page-sizes="[20, 50, 100]"
        :page-size="pageSize"
        :pager-count="5"
        layout="total, sizes, prev, pager, next, jumper"
        :total="total">
      </el-pagination>
    </div>
  </div>
</template>

<script>
// 这里可以导入其他文件（比如：组件，工具js，第三方插件js，json文件，图片文件等等）
// 例如：import 《组件名称》 from '《组件路径》';
import warnTypes from '@/store/types/warningcenter'
import timer from '@/utils/timer'
export default {
  // import引入的组件需要注入到对象中才能使用
  components: {},
  data () {
  // 这里存放数据
    return {
      loading: true,
      timerFun: '',
      height: 10,
      selecttime: '',
      selecttime1: '',
      selecttime2: '',
      tableData: [],
      warnNM: '',
      warnTMMin: '',
      warnTMMax: '',
      pageIndex: 1,
      pageSize: 20,
      total: 0
    }
  },
  // 监听属性 类似于data概念
  computed: {},
  // 监控data中的数据变化
  watch: {},
  // 方法集合
  methods: {
    // 查看短信详情分页
    handleSizeChangeDialog (val) {
      this.pageIndex = 1
      this.pageSize = val
      this.getTableData()
    },
    handleCurrentChangeDialog (val) {
      this.pageIndex = val
      this.getTableData()
    },
    // 选择行数据
    handleCurrentChange (val) {
      this.currentRow = val
    },
    // 获取数据
    getTableData () {
      this.loading = true
      this.$store.dispatch(warnTypes.GET_WARNRECORD_LIST, {
        warnNM: this.warnNM,
        warnTM_Min: this.warnTMMin,
        warnTM_Max: this.warnTMMax,
        pageIndex: this.pageIndex,
        pageSize: this.pageSize
      }).then(data => {
        this.tableData = data.results
        this.total = data.total
        this.loading = false
      })
    },
    // 导出
    exportdata () {
      this.$store.dispatch(warnTypes.WARN_INFOLIST_EXPORT, {
        warnNM: this.warnNM,
        warnTM_Min: this.warnTMMin,
        warnTM_Max: this.warnTMMax
        // pageIndex: 1,
        // pageSize: 2000
      }).then(data => {
        window.location.href = this.Global.basePath + data.data
      })
    },
    // 设置默认起止时间
    setDefaultTime () {
      var date = new Date()
      var warnTMMinMs = date.getTime() - 30 * 3600 * 1000 * 24
      var minDate = new Date(warnTMMinMs)
      this.warnTMMax = this.$moment(date).format('YYYY-MM-DD HH:mm')
      this.warnTMMin = this.$moment(minDate).format('YYYY-MM-DD HH:mm')
    }
  },
  // 生命周期 - 创建完成（可以访问当前this实例）
  created () {

  },
  // 生命周期 - 挂载完成（可以访问DOM元素）
  mounted () {
    this.setDefaultTime()
    this.getTableData()
    this.timerFun = setInterval(() => {
      this.setDefaultTime()
      this.getTableData()
    }, timer.TIMER_MIN)
    this.$nextTick(() => {
      let warnInformationViewDiv = document.getElementsByClassName('warnInformationView')
      let smsTopDiv = document.getElementsByClassName('sms_top')
      this.$refs['sms_bottom'].style.height = (warnInformationViewDiv[0].offsetHeight - smsTopDiv[0].offsetHeight - 45) + 'px'
      this.height = this.$refs['sms_bottom'].offsetHeight - 50
    })
  },
  beforeCreate () {}, // 生命周期 - 创建之前
  beforeMount () {}, // 生命周期 - 挂载之前
  beforeUpdate () {}, // 生命周期 - 更新之前
  updated () {}, // 生命周期 - 更新之后
  beforeDestroy () {
    clearInterval(this.timerFun)
  }, // 生命周期 - 销毁之前
  destroyed () {}, // 生命周期 - 销毁完成
  activated () {} // 如果页面有keep-alive缓存功能，这个函数会触发
}
</script>
<style lang="less" src="@/assets/warningcenter.less" scoped></style>
<style lang="less" scoped>
  #export{
    padding: 9px 8px;
    background-color: #1d8af8;
    cursor: pointer;
    float: right;
    color: #ffffff;
    border-radius: 3px;
    margin-right: 20px;
    font-size:16px;
  }
  .export-icon{
    width: 18px;
    height: 17px;
    display: inline-block;
    background-image: url(../../../assets/monitorimg/export.png);
    background-size: 100% 100%;
    background-repeat: no-repeat;
    margin-right: 5px;
    vertical-align: middle;
  }
    /* 外层样式 */
    .warnInformationView{
        width: 100%;
        padding: 15Px;
        height: 100%;
        position: relative;
        // top: -80px;
        /deep/ .el-table th {
          background: #F5F7FA!important;
        }
        /deep/ .el-table--enable-row-hover .el-table__body tr:hover>td {
          background-color: #ecf5ff;
        }
    }
    /* top */
    .sms_top{
        width: 100%;
        height: 80px;
        margin-bottom: 15Px;
        padding:15px;
        background: #ffffff;
    }
    .sms_top .select .desc{
        width: 80px;
        height: 35px;
        float: left;
        font-size:16px;
        font-family:Microsoft YaHei UI;
        line-height: 40px;
    }
    .sms_top .select{
        width: 560px;
        height: 35px;
        float: left;
    }
    .sentType{
        width: 325px;
        float: left;
    }
    .sentType .fsfs{
        width: 80px;
        height: 35px;
        float: left;
        font-size:16px;
        font-family:Microsoft YaHei UI;
        line-height: 40px;
    }
    .sentType .selectContent{
        width: 225px;
        float: left;
    }
    .sms_top #search{
        width: 75px;
        height: 38px;
        float: left;
        margin-left: 10px;
        background: #1d8af8;
        border: 0.03125rem solid #1d8af8;
        color: #fff;
        text-align: center;
        font-size: 16px;
        line-height: 20px;
        border-radius: 5px;
        cursor: pointer;
    }
    /* bottom */
    .sms_bottom{
      width: 100%;
      height: 100%;
      background-color: #fff;
      border-radius: 5px;
      padding-top: 15Px;
      padding-bottom: 15Px;
      > div {
        width: 98%;
        margin-left: 1%;
      }
    }
    /* 查看弹窗 */
    .smsDetails_dialog .el-dialog__header{
      border-bottom: 1px solid #cccccc
    }
    .smsDetails_dialog .smsDetailFilter{
      width: 100%;
      height: 45px;
    }
    .smsDetails_dialog .smsDetailFilter .el-form{
      width: 85%;
      height: 45px;
      float: left;
    }
    .smsDetails_dialog .smsDetailFilter .el-button{
      width: 75px;
      height: 38px;
      float: left;
      margin-left: 10px;
      background: #1d8af8;
      border: 0.03125rem solid #1d8af8;
      color: #fff;
      text-align: center;
      font-size: 16px;
      line-height: 20px;
      border-radius: 5px;
      cursor: pointer;
    }
    .smsDetails_dialog .el-form-item{
      margin-right: 20px;
      display: inline-block;
      margin-left: 0;
      margin-bottom: 5px;
    }
    .smsDetails_dialog .el-form-item:nth-child(1){
      width: 250px;
      height: 40px;
    }
    .smsDetails_dialog .el-form-item:nth-child(2){
      width: 200px;
      height: 40px;
    }
    .smsDetails_dialog .el-form-item:nth-child(3){
      width: 250px;
      height: 40px;
    }
    .smsDetails_dialog .el-form-item__label {
      width: 100px;
    }
    /* led */
    .smsDetails_dialog .led .smsDetailFilter .el-form{
      width: 30%;
    }
</style>
